import { map, share } from 'rxjs/operators';
import { LocalStorageDataStream, messaging } from '@pendo/services/Communication';

const { messageChannels, messageType } = messaging;

export function listenToDesigner (store) {
    const localStorageDataStream = new LocalStorageDataStream('localStorage', 'pendo', false);
    localStorageDataStream.listen();
    const appEngineMessage$ = localStorageDataStream.getMessagesForChannel$(messageChannels.APPENGINE).pipe(
        map((envelope) => envelope.message),
        share(),
    );

    appEngineMessage$.subscribe((message) => {
        if (message.type === messageType.RELOAD_LAYOUTS) {
            store.dispatch('layouts/loadAll', { reFetch: true });
        } else if (message.type === messageType.RELOAD_THEMES) {
            store.dispatch('themes/loadAll', { reFetch: true });
        }
    });
}
